import React, { useState } from "react";
import { Center } from "@astryxdesign/core/Center";
import { Stack } from "@astryxdesign/core/Stack";
import { Card } from "@astryxdesign/core/Card";
import { Text, Heading } from "@astryxdesign/core/Text";
import { Button } from "@astryxdesign/core/Button";
import { Spinner } from "@astryxdesign/core/Spinner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import AstryxTheme from "./theme/AstryxTheme";
import Header from "./components/Header/Header";
import CompaniesTable from "./components/CompaniesTable/CompaniesTable";
import UserManagement from "./components/UserManagement/UserManagement";
import FileManager from "./components/FileManager/FileManager";
import FleetBackfill from "./components/FleetBackfill/FleetBackfill";
import Relatorios from "./components/Relatorios/Relatorios";
import ConferenciaLancamentos from "./components/ConferenciaLancamentos/ConferenciaLancamentos";
import Login from "./components/Login/Login";
import "./fontawesome"; // Importar configuração do Font Awesome

function HubAccessDenied() {
  const { logout, user } = useAuth();
  return (
    <AstryxTheme>
      <Center>
        <Stack minHeight="100vh" width="100%" maxWidth={440} justify="center" paddingInline={4}>
          <Card padding={6}>
            <Stack gap={3} hAlign="center">
              <Heading level={1}>Acesso ao Hub NFSe</Heading>
              <Text justify="center">
                Sua conta ({user?.email}) não tem permissão para usar o Hub
                NFSe. Entre pelo Monitor 360 ou peça a um administrador para
                habilitar o acesso.
              </Text>
              <Button label="Sair" variant="primary" onClick={logout} />
            </Stack>
          </Card>
        </Stack>
      </Center>
    </AstryxTheme>
  );
}

//Aqui se cria o componente principal da aplicação, sua existência se dá por uma necessidade técnica na utilização do Context API
function AppContent() {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState("companies");

  if (loading) {
    // Se o usuário está carregando, exibe um spinner de carregamento
    return (
      <AstryxTheme>
        <Center>
          <Stack minHeight="100vh" justify="center" gap={2} hAlign="center">
            <Spinner size="lg" label="Carregando" />
            <Text type="supporting">Carregando...</Text>
          </Stack>
        </Center>
      </AstryxTheme>
    );
  }

  if (!user) {
    // Se o usuário não está logado, exibe o componente de login
    return <Login />;
  }

  if (user.access_hub_nfse === false) {
    return <HubAccessDenied />;
  }

  const renderContent = () => {
    return (
      <>
        {(() => {
          switch (activeTab) {
            case "companies":
              return <CompaniesTable />;
            case "files":
              return <FileManager />;
            case "fleet":
              // Aba só existe p/ admin/normal (ver Navigation); o backend
              // barra o cliente de qualquer forma (requireRole).
              return <FleetBackfill />;
            case "reports":
              return <Relatorios />;
            case "users":
              return <UserManagement />;
            case "conferencia-lancamentos":
              // Aba só existe p/ admin (ver Navigation); o backend também
              // barra via requireAdmin na rota.
              return <ConferenciaLancamentos />;
            default:
              return <CompaniesTable />;
          }
        })()}
      </>
    );
  };

  return (
    <AstryxTheme>
      <Center>
        <Stack width="100%" maxWidth={1280} gap={6} padding={6}>
          <Header activeTab={activeTab} setActiveTab={setActiveTab} />

          {renderContent()}
        </Stack>
      </Center>
    </AstryxTheme>
  );
}

// Esse é o componente que renderiza o componente principal dentro de um contexto de autenticação
export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
